import JtlApiClient from "./base";

// Sheets Settings API
export const sheetsSettingsApi = {
  // Get current sheets settings
  getSettings: () => {
    return JtlApiClient.get("/sheets/settings");
  },

  // Update sheets settings (partial or complete update)
  updateSettings: (settings) => {
    return JtlApiClient.post("/sheets/settings", settings);
  },

  // Reset sheets settings to defaults
  resetSettings: () => {
    return JtlApiClient.delete("/sheets/settings");
  },
};
